function DateGeral({ dataDevolvendo, setDataDevolvendo, width }) {
  return (
    <div>
      <input
        type="date"
        value={dataDevolvendo}
        onChange={(e) => setDataDevolvendo(e.target.value)}
        style={{
          color: "var(--cor-preto)",
          backgroundColor: "var(--cor-branco)",
          border: "1px solid var(--cor-cinzaMargin)",
          marginTop: 5,
          fontSize: 20,
          margin: "none",
          borderRadius: 10,
          width: width,
          height: 47,
          fontFamily: "Roboto",
        }}
      />
    </div>
  );
}

export default DateGeral;
